import { Button, TextField, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { deletePartida, getPartidas } from "../../../../api/partida";
import { getPartidaCategories } from "../../../../api/partidaCategory";
import { ROLES } from "../../../../utils/constants";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import EntityInfoDialog from "../../../components/dialogs/EntityInfoDialog";
import FiltersCard from "../../../components/filters/Filter";
import Table, { buttonsStyle } from "../../../components/tables/table";
import PartidaContent from "./PartidaContent";

function getData(partidas) {
	let data = [];
	for (let i = 0; i < partidas.length; ++i) {
		const elem = {};
		const partida = partidas[i];

		elem.referencia = partida?.referencia;
		elem.descripcion = partida?.descripcion;
		elem.categoria = partida?.categoria?.descripcion;
		elem.id = partida?.id;

		data = data.concat(elem);
	}
	return data;
}

const initialFilters = {
	categorias: [],
};

export default function PartidasPage() {
	const [data, setData] = useState([]);
	const [selectedPartida, setSelectedPartida] = useState(null);

	const [partidaCategories, setPartidaCategories] = useState([]);

	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [openPartidaInfoDialog, setOpenPartidaInfoDialog] = useState(null);

	const [refresh, setRefresh] = useState(false);

	const [filteredData, setFilteredData] = useState([]);
	const [collapsed, setCollapsed] = useState(true);
	const [filterOptions, setFilterOptions] = useState(initialFilters);

	const history = useHistory();

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function buttonFormatter(cell) {
		const elem = data.find((item) => item.id === cell);
		return (
			<>
				<Tooltip title="Editar">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={(e) => {
							e.stopPropagation();
							history.push("/partidas/" + cell + "/edit");
						}}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				{loggedUser?.role?.rango === ROLES.SUPER_ADMIN && (
					<>
						<Tooltip title="Eliminar">
							<Button
								style={buttonsStyle}
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									setSelectedPartida(elem);
									setOpenConfirmDialog(2);
								}}
							>
								<DeleteIcon />
							</Button>
						</Tooltip>
					</>
				)}
			</>
		);
	}

	const columns = [
		{ dataField: "referencia", text: "Referencia", sort: true },
		{
			dataField: "descripcion",
			text: "Descripción",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{
			dataField: "categoria",
			text: "Categoría",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	useEffect(() => {
		getPartidaCategories(loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					setPartidaCategories(res.data);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "No se han podido obtener las categorías.",
				});
			});
		getPartidas(loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					setData(res.data);
					setFilteredData(res.data);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "No se han podido obtener las partidas.",
				});
			});
	}, [refresh]);

	const handleSearch = async () => {
		if (!data.length) return;
		setFilteredData(
			data.filter((item) => {
				let filter = true;
				if (
					filterOptions.categorias &&
					filterOptions.categorias.length > 0
				)
					filter =
						filter &&
						filterOptions.categorias?.some(
							(x) => x.id === item?.categoria?.id
						);

				if (filter) return item;
				return false;
			})
		);
	};

	const handleClearFilters = () => {
		setFilterOptions(initialFilters);
		setRefresh(true);
	};

	const renderFiltersContent = () => {
		return (
			<>
				<div className="d-sm-flex w-100">
					<Autocomplete
						className="w-100 mr-5"
						multiple
						id="autocomplete-categorias"
						filterSelectedOptions
						options={partidaCategories}
						getOptionLabel={(option) => option?.descripcion}
						value={filterOptions.categorias || []}
						onChange={(event, selected) => {
							setFilterOptions({
								...filterOptions,
								categorias: selected,
							});
						}}
						renderInput={(params) => (
							<TextField
								{...params}
								margin="normal"
								variant="outlined"
								InputLabelProps={{
									shrink: true,
								}}
								label="Categoría"
							/>
						)}
					/>
				</div>
			</>
		);
	};

	return (
		<>
			<Card>
				<CardHeader headerClassName="px-0">
					<CardHeader
						title="Partidas"
						sticky={false}
						headerClassName="d-flex justify-content-between w-100 py-3"
					>
						<CardHeaderToolbar>
							<button
								type="button"
								className="btn btn-primary"
								onClick={() => history.push("/partidas/edit")}
							>
								Nueva partida
							</button>
						</CardHeaderToolbar>
					</CardHeader>
					<div className="w-100">
						<FiltersCard
							collapsable={false}
							filtersContent={renderFiltersContent}
							collapsed={collapsed}
							setCollapsed={setCollapsed}
							handleClearFilters={handleClearFilters}
							handleSearch={handleSearch}
						/>
					</div>
				</CardHeader>
				<CardBody>
					<Table
						data={getData(filteredData)}
						columns={columns}
						rowEvents={{
							onClick: (e, row, rowIndex) => {
								const partida = data?.find(
									(x) => x.id === row.id
								);
								setSelectedPartida(partida);
								setOpenPartidaInfoDialog(true);
							},
						}}
					/>
					<ConfirmDialog
						title={
							"¿Estás seguro de que quieres eliminar esta partida?"
						}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deletePartida(
								selectedPartida?.id,
								loggedUser?.accessToken
							)
								.then((res) => {
									if (
										res.status === 204 ||
										res.status === 200
									) {
										alertSuccess({
											title: "¡Eliminada!",
											customMessage:
												"Partida eliminado con éxito.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"No se ha podido eliminar la partida.",
									});
								});
						}}
					/>
					<EntityInfoDialog
						title={"Partida: " + selectedPartida?.descripcion}
						open={openPartidaInfoDialog}
						setOpen={setOpenPartidaInfoDialog}
						content={<PartidaContent partida={selectedPartida} />}
					/>
				</CardBody>
			</Card>
		</>
	);
}
